import { createContext, useState } from "react";
export const BatchImagesContext = createContext()

export const BatchImagesContextProvider = (props) => {
    const [fileList, setFileList] = useState([])
    const [referenceResList, setReferenceResList] = useState([])
    const [projectType, setProjectType] = useState('')
    const [selectSkuId, setSelectSkuId] = useState('')


    return (
        <BatchImagesContext.Provider value={{
            fileList, setFileList,
            projectType, setProjectType,
            referenceResList, setReferenceResList,
            selectSkuId, setSelectSkuId,
        }}>
            {props.children}
        </BatchImagesContext.Provider>
    );
}
